import React from "react";
import Select from "react-select";
import { Button } from "@wac-ui-dashboard/wac_component_library";
import useFilter from "./useFilter";

const Filter = () => {
  const { formik, basicData, handleReset } = useFilter();
  return (
    <div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Customer Type
        </label>
        <Select
          id="customer_type"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          name="customer_type"
          options={basicData?.data?.customer_type || []}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.name}
          value={
            basicData?.data?.customer_type?.find(
              (m) => m?.id === formik.values.customer_type,
            ) ?? null
          }
          onChange={(value) =>
            formik.setFieldValue("customer_type", value?.id ?? "")
          }
          menuPlacement="auto"
          isClearable
        />
      </div>
      <div className="input-wrap pro-mb-4">
        <label htmlFor="" className="pro-font-sm pro-mb-1 pro-fw-medium">
          Add As
        </label>
        <Select
          id="add_as"
          placeholder={"Select"}
          className={"pro-input lg"}
          classNamePrefix="pro-input"
          name="add_as"
          options={basicData?.data?.add_as || []}
          getOptionValue={(option) => option?.id}
          getOptionLabel={(option) => option?.name}
          value={
            basicData?.data?.add_as?.find(
              (m) => m?.id === formik.values.add_as,
            ) ?? null
          }
          onChange={(value) => formik.setFieldValue("add_as", value?.id ?? "")}
          menuPlacement="auto"
          isClearable
        />
      </div>
      <div
        className={`col-12 pro-d-flex pro-justify-end ${"offcanvas-footer-sticky-btn"}`}
      >
        <Button className={"pro-btn-link lg pro-px-5"} onClick={handleReset}>
          Reset
        </Button>

        <Button
          className={"pro-btn-primary lg pro-ms-3"}
          type="submit"
          onClick={formik.handleSubmit}
        >
          Apply
        </Button>
      </div>
    </div>
  );
};

export default Filter;
